const fs = require('fs')

function writeFile(file, string) {
  fs.writeFileSync(file, string)

  return true
}

function openNewTab(file) {
  const url = window.URL.createObjectURL(file)
  window.open(url, '_blank').focus()
}

async function downloadFromUrl(path) {
  return fetch(path)
    .then(response => {
      if (!response.ok) throw new Error(response.text())
      return response.blob();
    })
    .then(blob => {
      const url = window.URL.createObjectURL(blob);
      const filename = path.substring(path.lastIndexOf("/") + 1);
      const a = document.createElement('a');
      a.href = url;
      a.download = filename
      document.body.appendChild(a);
      a.click();
      a.remove();
      window.URL.revokeObjectURL(url);
    })
}

module.exports = {
  writeFile,
  openNewTab,
  downloadFromUrl,
}
